module.exports = __webpack_public_path__ + "media/icons/tw-6a65d938.png";